import type { EditorProps } from "../viewer/common/Types.ts";
import TemplateTypeSelector from "./TemplateTypeSelector.tsx";
import type { ReportTemplate } from "../../../../../../api/types/svTypes.ts";

interface Props {
  Editor: React.ComponentType<EditorProps>;
  template: ReportTemplate;
}

const TemplateEditor = ({ Editor, template }: Props) => (
  <Editor ReportTypeSelector={<TemplateTypeSelector template={template} />} exportAllowed={false} />
);

export default TemplateEditor;
